var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left icon",
    clipPath: "url(#clip0_0_207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.0155 25.9875C4.879 26.7645 5.6455 27.3717 6.321 27.0252L14.0035 23.0773L21.6842 27.0252C22.3597 27.3717 23.1263 26.7645 22.9898 25.9892L21.5372 17.7117L27.7008 11.8388C28.2783 11.2892 27.9808 10.2848 27.2072 10.1763L18.6358 8.95825L14.8138 1.386C14.7409 1.23251 14.6261 1.10282 14.4825 1.01201C14.3389 0.921203 14.1725 0.872998 14.0026 0.872998C13.8327 0.872998 13.6663 0.921203 13.5228 1.01201C13.3792 1.10282 13.2643 1.23251 13.1915 1.386L9.3695 8.96L0.798 10.178C0.02625 10.2865 -0.273 11.291 0.30275 11.8405L6.468 17.7135L5.0155 25.991V25.9875ZM13.5992 21.1452L7.14875 24.4598L8.36325 17.535C8.39248 17.3756 8.38173 17.2114 8.33195 17.0572C8.28217 16.903 8.19491 16.7635 8.078 16.6513L2.9925 11.8038L10.0835 10.7958C10.2301 10.7729 10.3691 10.7152 10.4887 10.6275C10.6084 10.5398 10.7053 10.4246 10.7713 10.2918L14 3.89025L17.2322 10.2918C17.2982 10.4246 17.3951 10.5398 17.5148 10.6275C17.6344 10.7152 17.7734 10.7729 17.92 10.7958L25.011 11.802L19.9255 16.6495C19.8083 16.7619 19.7209 16.9017 19.6711 17.0562C19.6213 17.2108 19.6107 17.3753 19.6403 17.535L20.8548 24.4598L14.4043 21.1452C14.2796 21.0805 14.1413 21.0467 14.0009 21.0467C13.8605 21.0467 13.7239 21.0805 13.5992 21.1452Z",
    fill: "#5E677D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatings);
export default __webpack_public_path__ + "static/media/ratings.85208e03b5a6e211bf3636a1c9c9c9ec.svg";
export { ForwardRef as ReactComponent };